<template>
  <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
  <div id="about-us-container">

    <div class="about-us">
      <img v-if="infos.image" :src="$store.state.base_urls.webUploads + infos.image" alt="faq">
      <div class="title">
        <ul>
          <li>
            <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
          </li>
          <li>
            درباره
            <span>
                کانادا از ایران
            </span>
          </li>
        </ul>
      </div>
      <div id="main-content" v-if="infos"  v-html="infos.about"></div>
    </div>
    <div id="important-information-container"  v-if="infos.cases_count_one && infos.cases_count_two">
      <div id="important-information">
          <div  class="row" style="padding: 0">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="number-container">
                <div class="box-border-top-left"></div>
                <div class="box-border-bottom-right"></div>
                <div class="number-container-cover"></div>
                <span class="number">{{infos.cases_count_one.split(",")[0]}}</span>
                <br/>
                <span  class="number-description">{{infos.cases_count_one.split(",")[1]}}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="number-container">
                <div class="box-border-top-left"></div>
                <div class="box-border-bottom-right"></div>
                <div class="number-container-cover"></div>
                <span class="number">{{infos.cases_count_two.split(",")[0]}}</span>
                <br/>
              <span class="number-description">{{infos.cases_count_two.split(",")[1]}}</span>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div id="certificate-container" v-if="infos.documents">
      <div class="title">
        <ul>
          <li>
            <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
          </li>
          <li>
            مدارک و مجوز های رسمی
            <span>
      کانادا از ایران
      </span>
          </li>
        </ul>
      </div>
      <div id="footer-content"  v-if="infos.documents">
        <div class="row">
          <div class="small-div col-lg-4 col-md-4 col-sm-12 mt-2" v-for="document in infos.documents.split(',')" :key="document">
            <div>
              <img :src="$store.state.base_urls.webUploads + document" alt="document">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="pageLoadingMood">
      <img style="height: auto;margin-top: -200px;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
    </div>

      <div class="space"></div>
      <AboutUsSliderOne/>
      <div class="space"></div>
      <div id="latest-achievements">
      <div class="title">
        <ul>
          <li>
            <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
          </li>
          <li>
            آخرین موفقیت های
            <span>
      کانادا از ایران
      </span>
          </li>
        </ul>
      </div>
      <span id="description"   v-if="infos.explain">
      {{infos.explain}}
      </span>
      <div v-if="pageLoadingMood">
          <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
      </div>
      <AboutUsSliderTwo/>


  </div>
</template>
<script>
  import AboutUsSliderOne from '../components/AboutUsSliderOne'
  import AboutUsSliderTwo from '../components/AboutUsSliderTwo'
  import Alert from '../components/Alert'
  import axios from 'axios'
  export default {
    name: "about-us",
    components:{
      AboutUsSliderOne,
      AboutUsSliderTwo,
      Alert,
    },
    data(){
      return {
        alertContent: null,
        pageLoadingMood:false,
        infos:
                {
                  image:null,
                  about:null,
                  cases_count_one:null,
                  cases_count_two:null,
                  documents:null
                },
      }
    },
    methods:{
      async getPageInfos() {
        try {
          this.pageLoadingMood = true;
          let response = await axios.get('api/getPageInfos/aboutUs',
                  {
                    headers:
                            {
                              "Authorization": `Bearer ${localStorage.getItem('token')}`,
                            }
                  });
          this.pageLoadingMood = false;
          this.infos = response.data.results;

        } catch (error) {
          console.log(error)
        }
      },
    },
    mounted() {
      this.getPageInfos();
    },
  }
</script>
<style lang="scss" scoped>
  ul{
    padding: 0;
  }
  #description{
    display: block;
    width: 100%;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #1a1a1a;
  }
  .space{
    height: 10px;
    width: 100%;
    background-color: #162336;
  }
  .small-div{
    min-height: 140px;
    image{
      width: 100%;
      height: auto;
      position: absolute;
    }
    div{
      background-size: cover;
      background-repeat: no-repeat;
      padding: 10px;
      margin-top: 15px;
      width: 100%;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      span{
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        margin: 20px;
      }
      image{

      }
    }
  }


  #certificate-container{
    max-width: 1120px;
    width: 100%;
    background-color: white!important;
    margin: auto;
    padding: 10px 15px 50px 15px;
    img{
      height: auto;
      width:100% ;
    }
  }

  #latest-achievements{
    max-width: 1120px;
    width: 100%;
    background-color: white!important;
    margin: auto;
    padding: 10px 15px 50px 15px;
  }

  .box-border-top-left{
    width: 50%!important;
    height: 2px!important;
    border-left: 2px solid #fe7063;
    border-top: 2px solid #fe7063;
    position: absolute;
    left: -5px;
    top: -5px;

  }
  .box-border-bottom-right{
    width: 50%!important;
    height: 2px!important;
    border-right: 2px solid #fe7063;
    border-bottom: 2px solid #fe7063;
    position: absolute;
    bottom: -5px;
    right: -5px;
    z-index: 0;

  }
  .number{
    font-size: 36px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    z-index: 5000000;
    position: relative;
    color: #ffffff;
  }
  .number-description{
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    z-index: 5000000;
    position: relative;
  }

  #important-information-container{
    background-color: black;
    width: 100%;
    height: auto;
  }

  #important-information{
    width: 100%;
    min-height: 285px;
    height: auto;
    opacity: 1;
    background-image: url("../assets/appIcons/Pics/FlagRed.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    div{
      max-width: 1120px;
      width: 100%;
      margin: auto;
      padding: 50px 15px;
    }
  }
  .number-container{
    position: relative;
    color: white;
    max-width: 400px;
    min-height: 185px;
    height: auto;
    padding: 30px;
    position: relative;
    span{
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .number-container::before{
    content:'';
    background-color: #4285f4;
    width: 3px;
    height: 90%;
    bottom: 0;
    left: -7px;
  }

  .number-container-cover{
    background-color: gray;
    opacity: 0.7;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
  }
  #main-content{
    padding-top: 10px;
    padding-bottom: 50px;
    text-align: right;
  }
  #about-us-container{
    width: 100%;
    height: auto;
    background-color: white;
  }
  .about-us{
    max-width: 1120px;
    width: 100%;
    background-color: white!important;
    margin: auto;
    padding: 50px 15px;
    img{
      height: auto;
      width:100% ;
    }
  }
  .title{
    margin-top: 30px;
    width: 100%;
    text-align: right;
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1a1a1a;

    ul{
      display: flex;
      /*align-items: center;*/
      /*justify-content: right;*/
      list-style-type: none;
      li{

        padding: 5px;
        img{
          margin-top: 5px;
          width: 9px!important;
          height: auto!important;
        }
        display: inline-block;
        span{
          color: #cc171d;
        }
      }
    }

  }
</style>